import React from 'react';
import PropTypes from 'prop-types';

import { importStatic } from 'utils';

const propTypes = {
  fallbackSrc: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
};

const defaultProps = {
  fallbackSrc: '',
  isDesktop: true,
  src: '',
};

const testId = 'user-avatar';

class userAvatar extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.fallback = () => {
      if (this.props.fallbackSrc) {
        this.setState({ failed: true });
      }
    };
  }

  render() {
    const imgSize = this.props.isDesktop ? 34 : 32;

    if (this.state.failed) {
      return (
        <img
          data-testid={testId}
          alt="profile"
          src={this.props.fallbackSrc}
          width={imgSize}
          height={imgSize}
        />
      );
    } else {
      return (
        <img
          data-testid={testId}
          alt="profile"
          src={this.props.src || importStatic('/ui-router/images/default-user.png')}
          width={imgSize}
          height={imgSize}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = importStatic('/ui-router/images/default-user.png');
          }}
        />
      );
    }
  }
}

userAvatar.propTypes = propTypes;
userAvatar.defaultProps = defaultProps;

export default userAvatar;
